




































































































































































import { isOverseasVersion } from 'common-module/src/util';
import { defineComponent, ref, onMounted, onBeforeUnmount, nextTick, computed, getCurrentInstance, watch } from '@vue/composition-api';
import { Input, Select } from 'zk-ui';
import { templateRef } from '@vueuse/core';
import { useConfig } from '../hooks/useConfig';
import { useMessage } from '../hooks/useMessage';
import { useLocale } from '../hooks/useLocale';
import { useInputAssociation } from '../hooks/useInputAssociation';
import { IntentType, IntentTypeInputConfig } from '../dataType';
import { useIntention } from '../hooks/useIntention';
import { useIntentTypes } from '../hooks/useIntentTypes';
import type { Info } from '../hooks/useMessage';
import { habitRecord, getHabitRecord } from '../util/api';

interface robotChangeIntentParams {
  info: Info
  intent: IntentType
}
export default defineComponent({
  setup() {
    const text = ref<string>('');
    const input = templateRef<Input>('input');
    const inputRecommend = templateRef<Input>('inputRecommend');
    const intentRef = templateRef<Select>('intentRef');

    const loading = ref<boolean>(false);
    const initLoading = ref<boolean>(false);
    const recommendText = ref<string>('');
    const instance = getCurrentInstance()?.proxy!;
    const { t } = useLocale();
    const { sendMessage, intent, setIntent, recommendActive, setRecommendActive, getUserInfo } = useConfig();
    const { sendIntentionRecommend, verifySendIntention } = useIntention();
    const { addUserTextMessage, robotWaitWithAsyncOperation, sendMessageAndUpdateId, isWaitResponse, lastResponseMessage } = useMessage();
    const hasText = computed<boolean>(() => recommendActive.value ? recommendText.value.trim().length > 0 : removeAndCheckInputText(text.value, intentComparisonFormat()));
    const { intentTypes, getIntentInfo } = useIntentTypes();
    const currentIntentType = computed(() => intentTypes.value.find(n => n.type === intent.value));
    const hasIntent = computed<boolean>(() => !!currentIntentType.value);
    const defaultInput = computed<string>(() => currentIntentType.value?.defaultInput || '');
    const defaultPlaceholder = computed<string>(() => currentIntentType.value?.placeholder || '');
    const currentIntentText = computed<string>(() => currentIntentType.value?.text || '');
    const isDefaultInput = computed<boolean>(() => !!defaultInput.value && defaultInput.value === text.value);
    const userId = computed(() => getUserInfo().userId);
    const inputIsSend = computed<boolean>(() =>{
      if (recommendActive.value) {
        return true;
      }
      // 判断text中去掉/xx 后是否有字符串
      return !!intent.value && removeAndCheckInputText(text.value, intentComparisonFormat());
    });
    
    const defaultIntent = ref<IntentType>();
    watch(intent, (val) => {
      if (val) {
        habitRecord({
          linkIdList: [val],
          linkType: 'robot-chat-intent',
          projectId: 0,
          userId: userId.value
        });
      }
    });
    async function getDefaultIntent() {
      initLoading.value = true;
      const result = await getHabitRecord({
        linkType: 'robot-chat-intent',
        projectId: 0,
        userId: userId.value
      }).finally(() => {
        initLoading.value = false;
      });
      const intent = result.linkIdList?.[0];
      // || 'knowledge_qa';
      defaultIntent.value = intent;
      setDefaultIntent();
      console.log('-getDefaultIntent--', intent);
    }
    getDefaultIntent();
    const focus = () => input.value?.focus();
    const inputRecommendFocus = () => inputRecommend.value?.focus();

    // 是否联想判断
    const associateJudge = (firstChar:string, rangeText: string) => {
      //存在意图 匹配的上 则不需要联想
      if (intent.value) {
        if (!rangeText.includes(intentComparisonFormat())) {
          setIntent(undefined);
        }
        return intentComparisonFormat().startsWith(rangeText);
      }

      //场景：没有选择联想时自己手动输入匹配到意图的文字 则帮忙设置意图
      const inputIncludesIntent = intentTypes.value.find(i =>intentComparisonFormat(i.text) === rangeText)?.type;
      if (inputIncludesIntent) {
        setIntent(inputIncludesIntent);
        return false;
      }

      return firstChar === '/';
    };

    // 联想替换函数
    const associateTransition = (text: string, isSearch:boolean) => {
      if (intentComparisonFormat() !== text) {
        setIntent(undefined);
      }
      const searchChar = text.slice(1) || '';
      // 通过select选择器筛选
      intentRef.value.doQuery(isSearch ? searchChar : '');
      if (text === '/' || !isSearch) {
        intentRef.value.hoverIndex = 0;
      } else if (intentRef.value.realCanSelectOptions?.length) {
        intentRef.value.hoverIndex = intentTypes.value.findIndex(i => intentRef.value.realCanSelectOptions[0] === i.type);
      }
      associateValue.value = intent.value;
      setAssociateState(false);
      nextTick(()=>{
        if (intentRef.value.visibleOption.length > 0) {
          setAssociateState(true);
        }
      });
    };

    const { associateVisible, setAssociateState, associateValue, choose } = useInputAssociation(input, associateJudge, associateTransition);

    const sendInput = async () => {
      if (loading.value || isWaitResponse.value || !hasText.value) {
        return;
      }
      if (!hasIntent.value) {
        setAssociateState(true);
        associateTransition(text.value, false);
        intentRef.value.hoverIndex = 0;
        return;
      }
      loading.value = true;
      const actualText = text.value.replace(intentComparisonFormat(), '');
      try {
        const sendText = recommendActive.value ? t(`${defaultInput.value}`, { input:recommendText.value }) : actualText;

        const verifyText = recommendActive.value ? recommendText.value : sendText;
        const result = verifySendIntention(verifyText);
        if (result) {
          // 根据上一条消息判断是否需要问题询问卡片
          const recommendType = ['ai.intentionBack', 'ai.continueResult', 'ai.example'];
          const queryQuest = recommendType.includes(lastResponseMessage.value?.type);
          addUserTextMessage(sendText);
          instance.eventBus?.$emit('finish-guide-task', 'MEET_MY_AI_ASSISTANT_RISK');
          instance.eventBus?.$emit('finish-guide-task', 'MEET_MY_AI_ASSISTANT_REPORT');
          robotWaitWithAsyncOperation(() => sendIntentionRecommend(sendText, intent.value, queryQuest));
        } else {
          const msg = addUserTextMessage(sendText);
          robotWaitWithAsyncOperation(() => sendMessageAndUpdateId(msg, 'sendInput', sendText));
        }
        text.value = hasIntent.value ? intentComparisonFormat() : '';
        recommendText.value = '';
        instance.$track.send('WebIM_SendIntent',
          {
            Send_Type: '手动发送',
            Has_Recommend: recommendActive.value ? '是' : '否',
            Intent_Type: result ? `${intent.value} + help/?` : intent.value
          }, true);
      } finally {
        loading.value = false;
        nextTick(focus);
      }
    };
    
    const setDefaultIntent = () => {
      if (!defaultIntent.value) {
        return;
      }
      const info = getIntentInfo(defaultIntent.value as string);
      if (info) {
        setIntent(defaultIntent.value);
        text.value = `/${info?.text} `;
      }
    };
    onMounted(() => {
      instance.eventBus.$on('robot-change-indent', robotChangeIntent);
      focus();
      setDefaultIntent();
      setRecommendActive(false);
    });
    onBeforeUnmount(() => {
      instance.eventBus.$off('robot-change-indent', robotChangeIntent);
    });
    const changeIntent = (intentValue: IntentType, intentText: string) => {
      instance.$track.send('WebIM_ClickIntentTab', { Tab_From: intent.value, Tab_To: intentValue }, true);
      setIntent(intentValue);
      setRecommendActive(false);
      choose(intentComparisonFormat(intentText));
      nextTick(focus);
    };

    async function robotChangeIntent(params: robotChangeIntentParams) {
      const intentValue: IntentType = params.intent;
      let type: string = intentValue || '';
      if (['weekly_report', 'daily_report'].includes(type)) {
        type = 'work_report';
      } else if (type === 'sql_query') {
        type = 'knowledge_qa';
      }
      const intentType = intentTypes.value.find(i => i.type === type);
      if (intentType) {
        const actualText = text.value.replace(intentComparisonFormat(), '');
        text.value = `/${intentType.text} ${actualText}`;
        setIntent(intentType.type);
      }
    }
    const handleRecommendVisible = () => {
      setRecommendActive(!recommendActive.value);
      const trackType = recommendActive.value ? 'WebIM_CancelRecommend' : 'WebIM_ClickRecommend';
      instance.$track.send(trackType, { Intent_Type: intent.value }, true);
    };

    const onClearIntent = async () => {
      robotWaitWithAsyncOperation(() => sendMessage('clear', ''));
    };

    const navigateOptions = (e: KeyboardEvent, direction: string) => {
      if (associateVisible.value) {
        e.stopPropagation();
        e.preventDefault();
      }
      intentRef.value.handleNavigate(direction);
    };

    const intentComparisonFormat = (value?:string) => {
      if (value) {
        return '/' + value + ' ';
      }
      return '/' + currentIntentText.value + ' ';
    };


    const removeAndCheckInputText = (text:string, intentText:string) : boolean => {
      const regex = new RegExp(intentText, 'g');
      return text.replace(regex, '').trim().length !== 0;
    };

    return {
      t,
      text,
      hasText,
      loading,
      isDefaultInput,
      defaultInput,
      intentTypes,
      intent,
      hasIntent,
      currentIntent: intent,
      changeIntent,
      focus,
      inputRecommendFocus,
      sendInput,
      enterSend(e: KeyboardEvent) {
        if (e.shiftKey) {
          return;
        }
        if (!hasIntent.value && !associateVisible.value) {
          sendInput();
          e.preventDefault();
          return;
        }
        if (associateVisible.value) {
          intentRef.value.enterSelectedOption();
          const currentText = intentTypes.value.find(n => n.type === associateValue.value)?.text;
          changeIntent(associateValue.value, currentText || '');
          e.preventDefault();
          return;
        }
        e.preventDefault();
        sendInput();
      },
      handleRecommendVisible,
      recommendActive,
      recommendText,
      defaultPlaceholder,
      onClearIntent,
      associateVisible,
      navigateOptions,
      intentRef,
      associateValue,
      inputIsSend,
      intentComparisonFormat,
      closeAssociate() {
        setAssociateState(false);
      },
      showFreeTip: !isOverseasVersion,
      initLoading
    };
  }
});
